import { Flex, Button, Icon } from "@chakra-ui/react";
import GlobeIcon from "@root/assets/icons/globalicon";
import { AppDispatch } from "@root/store";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { updateLanguage as updateLanguageThunk } from "@root/store/thunks";
import { updateLanguage as updateLanguageAction } from "@root/store/slices/features/auth";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

export const LanguageToggle = ({
  languages,
  isSidebarOpen,
  isIcon = true,
}: any) => {
  const { i18n } = useTranslation("common");
  const dispatch = useDispatch<AppDispatch>();
  const isLoggedInUser: any = useSelector(getLoggedInUser);

  useEffect(() => {
    if (isLoggedInUser?.language) {
      const lang = isLoggedInUser.language;

      // 1. Set language in i18n
      i18n.changeLanguage(lang);

      // 2. Store language in localStorage
      localStorage.setItem("appLanguage", lang);
    }
  }, [isLoggedInUser?.language]);

  const handleLanguageChange = (langValue: string) => {
    i18n.changeLanguage(langValue);
    localStorage.setItem("appLanguage", langValue);

    // Update Redux state immediately so API headers reflect the new language
    dispatch(updateLanguageAction(langValue.toUpperCase()));

    // Sync with backend
    dispatch(
      updateLanguageThunk({
        language: langValue as "en" | "ko",
      })
    );
  };

  return (
    <Flex
      alignItems="center"
      bg="#F3F4F6"
      borderRadius="20px"
      fontWeight="500"
      fontSize="14px"
      px="4px"
      py="2px"
      maxW="200px"
      justifyContent="center"
      visibility={isSidebarOpen ? "visible" : "hidden"}
    >
      {isIcon && <Icon as={GlobeIcon} boxSize={5} color="#5C6670" />}
      {languages?.map((lang: any) => (
        <Button
          key={lang?.title}
          onClick={() => handleLanguageChange(lang?.value)}
          size="sm"
          variant={i18n.language === lang?.value ? "solid" : "ghost"}
          bg={i18n.language === lang?.value ? "white" : "transparent"}
          borderRadius="20px"
          color={i18n.language === lang?.value ? "#1C00B8" : "#5C6670"}
          _hover={{ bg: "white" }}
        >
          {lang?.title}
        </Button>
      ))}
    </Flex>
  );
};
